import axios from "api/axiosController";
import { getAccessToken } from "utils/auth";

export const getprouducts = async (params: any) => {
  const { sellerId, page, limit, search } = params;
  let uri = "/seller-pagination-products";

  let query: any = {
    sellerId,
    page,
    limit,
    filter: {
      searchString: search,
    },
  };

  if (/^\d+$/.test(search)) {
    query = {
      page,
      filter: {
        searchString: search,
      },
    };
  } else if (search === "") {
    query = {
      page,
      limit,
      sellerId,
    };
  }

  try {
    const res = await axios.post(uri, query, {
      headers: { Authorization: `Bearer ${getAccessToken()}` },
    });
    return res.data;
  } catch (e) {
    throw e;
  }
};

export const updateprouducts = async (data: any) => {
  let uri = `/update-seller-product`;

  try {
    const res = await axios.post(uri, data, {
      headers: { Authorization: `Bearer ${getAccessToken()}` },
    });
    return res.data;
  } catch (e) {
    throw e;
  }
};
